import type { PropsWithChildren } from "react";
import { Button, Card } from "@ptsd/uikit";
import type { ViewProps } from "tamagui";
import { Text, View } from "tamagui";

import { usePaymentContext } from "~/contexts/PaymentContext";

export type PaywallProps = PropsWithChildren<
  Omit<ViewProps, "children"> & { hideCard?: boolean; enabled: boolean }
>;
export const Paywall: React.FC<PaywallProps> = ({
  children,
  hideCard = false,
  enabled,
  style,
  ...rest
}) => {
  const { setIsOpened } = usePaymentContext();

  if (!enabled) return children;

  return (
    <View position="relative" alignItems="center" justifyContent="center">
      <View
        flex={1}
        width={"100%"}
        userSelect="none"
        pointerEvents="none"
        style={{ WebkitUserSelect: "none" }}
      >
        {children}
      </View>
      <View
        style={[
          {
            position: "absolute",
            zIndex: 8,
            borderRadius: "$5",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            WebkitBackdropFilter: "blur(4px)",
            backdropFilter: "blur(4px)",
            pointerEvents: "auto",
          },
          style,
        ]}
        {...rest}
      />
      {!hideCard && (
        <View zIndex={9} position="absolute">
          <Card
            padding={"$3.5"}
            justifyContent="center"
            alignItems="center"
            alignSelf="center"
            gap={"$2"}
            maxWidth={"90%"}
            $gtSm={{ maxWidth: 480 }}
          >
            <Text
              fontFamily={"$subtitle"}
              fontWeight={"$5"}
              fontSize={"$4"}
              lineHeight={"$4"}
              textAlign={"center"}
              color={"$gray-950"}
            >
              Я хочу отримати повні результати та почати піклуватись про себе
            </Text>
            <Button
              variant="primary"
              size="md"
              rounded="lg"
              onPress={() => setIsOpened(true)}
            >
              Отримати повні результати
            </Button>
          </Card>
        </View>
      )}
    </View>
  );
};
